import { CircularProgress, FormControlLabel, Grid, Switch, TextField } from '@material-ui/core'
import { Autocomplete } from 'components/Autocomplete'
import { makeStyles } from '@material-ui/styles'
import { SecaoGenerica } from 'components'
import { useCargoService } from 'hooks/useCargoService'
import { usePermissaoService } from 'hooks/usePermissaoService'
import { useSetorService } from 'hooks/useSetorService'
import { useCallback, useEffect, useState } from 'react'
import useRouter from 'utils/useRouter'

const useStyles = makeStyles((theme) => ({
  alert: {
    marginBottom: theme.spacing(3),
  },
  carregando: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    margin: 20,
  },
  formGroup: {
    marginTop: theme.spacing(2),
  },
  fieldHint: {
    margin: theme.spacing(1, 0),
  },
}))

export const Formulario = (props) => {
  const { className, dados, editar, form, touched, errors, onChange, onChangeValue, onSubmit, ...rest } = props
  const cargoService = useCargoService()
  const permissaoService = usePermissaoService()
  const setorService = useSetorService()
  const classes = useStyles()
  const router = useRouter()
  const [setores, setSetores] = useState([])
  const [cargos, setCargos] = useState([])
  const [permissoesSistema, setPermissoesSistema] = useState([])
  
  const rotaAdmin = router.location.pathname.startsWith('/usuarios')
  const fetchSetores = useCallback(async () => {
    if (rotaAdmin) {
      const setores = await setorService.listarSetoresAsync()
      setSetores(setores)
    } else {
      const setores = await setorService.listarSetoresExternos()
      setSetores(setores)
    }
  }, [rotaAdmin])

  const fetchCargos = useCallback(async () => {
    const cargos = await cargoService.listarCargosAsync(!rotaAdmin)
    setCargos(cargos)

  }, [rotaAdmin])


  const fetchPermissoesSistema = useCallback(async () => {
    const permissoes = await permissaoService.listarPermissoesAsync()
    if (permissoes) {
      setPermissoesSistema(permissoes)
    }
  }, [])

  /**
   * @description useEffect para chamar as funções fetchDados
   */
  useEffect(() => {
    fetchSetores()
    fetchCargos()
    if (rotaAdmin) {
      fetchPermissoesSistema()
    }
  }, [dados, fetchSetores, fetchCargos, fetchPermissoesSistema, rotaAdmin])

  const hasError = (field) => touched[field] && errors[field]


  const textFieldOptions = {
    variant: 'outlined',
    fullWidth: true,
    InputLabelProps: {
      shrink: true,
    },
  }

  return editar && !dados.id ? (
    <div className={classes.carregando}>
      <CircularProgress disableShrink />
    </div>
  ) : (
    <form id="form-edit-usuario" onSubmit={onSubmit} {...rest} className={className}>
      <Grid container spacing={2}>
        <Grid item md={6} sm={12} xs={12}>
          <TextField {...textFieldOptions} autoFocus error={hasError('nome')} helperText={hasError('nome') ? errors.nome[0] : null} label="NOME" name="nome" onChange={onChange} value={form.nome || ''} />
        </Grid>
        <Grid item md={3} sm={3} xs={12}>
          <TextField
            {...textFieldOptions}
            error={Boolean(hasError('cpf'))}
            helperText={hasError('cpf') ? errors.cpf[0] : null}
            label="CPF"
            name="cpf"
            disabled={editar}
            onChange={onChange}
            value={form.cpf || ''}
            required
          />
        </Grid>
        <Grid item md={3} sm={3} xs={12}>
          <TextField {...textFieldOptions} error={hasError('matricula')} helperText={hasError('matricula') ? errors.matricula[0] : null} label="MATRÍCULA" name="matricula" onChange={onChange} value={form.matricula || ''} />
        </Grid>
        <Grid item md={4} sm={4} xs={12}>
          <TextField {...textFieldOptions} error={hasError('email')} helperText={hasError('email') ? errors.email[0] : null} label="E-MAIL" name="email" onChange={onChange} value={form.email || ''} multiline />
        </Grid>
      </Grid>
      <SecaoGenerica titulo="Informações Institucionais" spacing={2}>
        <Grid item xs={12}>
          <Autocomplete
            multiple
            label="SETORES"
            name="setores"
            value={form.setores || []}
            options={setores}
            onChange={(event, newValue) => {
              onChangeValue('setores', newValue)
            }}
            getOptionLabel={(option) => `${option.nome} - ${option.divisao.sigla} - ${option.divisao.regional.sigla} - ${option.divisao.regional.orgao.sigla}`}
            getTagLabel={(option) => option.sigla}
            getTagTooltip={(option) => `${option.nome} - ${option.divisao.sigla} - ${option.divisao.regional.sigla} - ${option.divisao.regional.orgao.sigla}`}
            required
          />
        </Grid>
        <Grid item md={4} sm={4} xs={12}>
          <Autocomplete
            name="cargo"
            label="CARGO"
            value={form.cargo || null}
            options={cargos}
            onChange={(event, newValue) => {
              onChangeValue('cargo', newValue)
            }}
            required
          />
        </Grid>
      </SecaoGenerica>
      {rotaAdmin && (
      <SecaoGenerica titulo="Permissões" spacing={2}>
        <Grid item md={6} sm={6} xs={12}>
          <Autocomplete
            multiple
            name="permissoesAdicionais"
            label="PERMISSÕES ADICIONAIS"
            value={form.permissoesAdicionais || []}
            options={permissoesSistema}
            onChange={(event, newValue) => {
              onChangeValue('permissoesAdicionais', newValue)
            }}
            getOptionLabel={(option) => `${option.nome} - ${option.descricao}`}
            getTagLabel={(option) => option.nome}
            getTagTooltip={(option) => option.descricao}
            required
          />
        </Grid>
        <Grid item md={6} sm={6} xs={12}>
          <Autocomplete
            multiple
            name="permissioesNegadas"
            label="PERMISSÕES NEGADAS"
            value={form.permissoesNegadas || []}
            options={permissoesSistema}
            onChange={(event, newValue) => {
              onChangeValue('permissoesNegadas', newValue)
            }}
            getOptionLabel={(option) => `${option.nome} - ${option.descricao}`}
            getTagLabel={(option) => option.nome}
            getTagTooltip={(option) => option.descricao}
            required
          />
        </Grid>
      </SecaoGenerica>)}
      {!editar && (<FormControlLabel label="Notificar usuário?" control={<Switch checked={form.notificacao || false} name="notificacao" onChange={onChange} />} />)}
    </form>
  )
}
